// lbl.example.
export const example = {
    monthPicker: {
        name: 'Month/Year',
        placeholder: '',
        required: 'Please select month/year',
        too_short: '',
        invalid: '',
        month: {
            name: '',
            placeholder: 'Month',
            required: ' '
        },
        year: {
            name: '',
            placeholder: 'Year',
            required: ' '
        },
    },
}
